/**
 * Single dayjs setup for the whole app.
 *
 * Plugins and the locale are registered once here; importing `dayjs` from
 * this module anywhere else guarantees they are present. Formatting helpers
 * used to call `dayjs.extend(...)` on every invocation — hundreds of times
 * per render on large tables — which this file makes unnecessary.
 */
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);
dayjs.locale('pt-br');

export type { Dayjs } from 'dayjs';
export default dayjs;
